import { Image } from '@/types/image'

import { createEmptyCopyrightImage } from './createEmptyCopyrightImage'

export const createEmptyImage = (): Image => ({
  url: '',
  id: 0,
  copyrightImage: createEmptyCopyrightImage(),
})
